import React, { FC } from 'react';
import styled from 'styled-components';

import { AppDigest } from './AppDigest';
import App from '../../../models/app';

const AppCardContainer = styled.div`
  border-bottom: 1px solid #E7E9EA;
  background: #FFFFFF;
`;

interface AppListItemProps {
  app: App;
  collectionId?: string;
}

export const AppListItem: FC<AppListItemProps> = ({ app, collectionId, ...props }) => (
  <AppCardContainer>
    <AppDigest app={app} collectionId={collectionId} {...props} />
  </AppCardContainer>
);
